module.exports = __webpack_public_path__ + "static/media/documents.3eb28e06.svg";